// Spanish translation

const es = {
  "menu.staff_assistance": "Control de Asistencia",
  "menu.assistance": "Control de Asistencia",
  "menu.audit": "Auditoría de Asistencia",
  "staff.assistance.main_desc":
    "Controla y audita la asistencia de tu personal, registrando horarios, ausencias y novedades de forma rápida y sencilla.",
  "staff.assistance.control_title": "Control de Asistencia",
  "staff.assistance.control_desc":
    "Registra y gestiona las asistencias del personal.",
  "staff.assistance.audit_title": "Auditoría de Asistencia",
  "staff.assistance.audit_desc":
    "Audita y verifica los registros de asistencia.",
  "staff.assistance.audit.search": "Buscar",
  "staff.assistance.audit.empty":
    "Selecciona las fechas y presiona Buscar para auditar la asistencia.",
  "staff.assistance.audit.no_data":
    "No se encontraron registros para los filtros seleccionados.",
  "staff.assistance.audit.require_dates":
    "La fecha inicial es obligatoria.",
  "staff.assistance.audit.start_date": "Fecha Inicial",
  "staff.assistance.audit.end_date": "Fecha Final",
  "staff.access.audit.name": "Empleado",
  "staff.access.audit.shift_code": "Turno",
  "staff.access.audit.enter_shift": "Ing. Turno",
  "staff.access.audit.exit_shift": "Sal. Turno",
  "staff.access.audit.enter_effective": "Ing. Efectiva",
  "staff.access.audit.exit_effective": "Sal. Efectiva",
  "staff.access.audit.enter_biometric": "Ing. Bio.",
  "staff.access.audit.exit_biometric": "Sal. Bio.",
  "staff.access.audit.ttt": "TTT",
  "staff.access.audit.hedo": "HEDO",
  "staff.access.audit.heno": "HENO",
  "staff.access.audit.hedf": "HEDF",
  "staff.access.audit.henf": "HENF",
  "staff.access.audit.reco": "RECO",
  "staff.access.audit.recf": "RECF",
  "staff.access.dom": "DOM",
  "staff.access.audit.view_events": "Novedades",
  "staff.access.audit.events_empty":
    "El empleado no registra novedades en el rango seleccionado.",
  "staff.access.audit.events_category": "Categoría",
  "staff.access.audit.events_description": "Descripción",
  "staff.access.audit.events_date": "Fecha",
  "staff.access.audit.events_range": "Rango",
  "staff.access": "Control de Asistencia",
  "staff.access.employee": "Empleado",
  "staff.access.employee.filter": "Filtrar empleado",
  "staff.access.enter_timestamp": "Entrada",
  "staff.access.exit_timestamp": "Salida",
  "staff.access.start_rest": "Inicio Descanso",
  "staff.access.end_rest": "Fin Descanso",
  "staff.access.enter_biometric": "Entrada Bio.",
  "staff.access.exit_biometric": "Salida Bio.",
  "staff.access.state": "Estado",
  "staff.access.state.filter": "Filtrar estado",
  "staff.access.activity": "Actividad",
  "staff.access.extras_approval": "Aprobación de Horas Extras",
  "staff.access.request_reason": "Causa de la Solicitud",
  "staff.access.is_billable": "Es Facturable",
  "staff.access.create_shift_schedule": "Crear Asistencia",
  "staff.access.create_access_filter": "Filtrar",
  "staff.access.start_date": "Fecha Inicial",
  "staff.access.end_date": "Fecha Final",
  "staff.access.type": "Tipo",
  "staff.access.entry": "Entrada",
  "staff.access.exit": "Salida",
  "staff.access.both": "Ambos",
  "staff.access.create_staff_assistance": "Crear Asistencia",
  "staff.access.close_staff_assistance": "Cerrar",
  "staff.access.kind_start": "Hora Inicio",
  "staff.access.kind_start_rest": "Inicio Descanso",
  "staff.access.kind_end_rest": "Fin Descanso",
  "staff.access.kind_end": "Finalizar",
  "staff.access.shift_info": "Información del Turno",
  "staff.access.shift": "Turno",
  "staff.access.section": "Sección",
  "staff.access.section.filter": "Filtrar sección",
  "staff.access.extras": "Extras",
  "staff.access.close": "Cerrado",
  "staff.access.shift_unit_cost": "Costo Unit.",
  "staff.access.is_billable.billable": "Facturable",
  "staff.access.is_billable.no_billable": "No Facturable",
  "staff.access.state.open": "Abierto",
  "staff.access.state.close": "Cerrado",
  "staff.access.state.done": "Finalizado",
  "staff.access.state.approved": "Aprobado",
  "staff.access.state.not_approved": "No Aprobado",
  "staff.access.enter_permission": "Permiso Entrada",
  "staff.access.exit_permission": "Permiso Salida",
  "staff.access.daily_report": "Reporte de Asistencia Diaria",
  "staff.access.daily_report.description": "Reporte de Asistencia Diaria",
  "staff_access.daily_report.start_date": "Fecha Inicial",
  "staff_access.daily_report.end_date": "Fecha Final",
  "staff_access.daily_report.section": "Sección",
  "staff_access.daily_report.kind": "Clase",
  "staff_access.daily_report.only_overtime": "Solo Extras",
  "staff.access.ttt": "TTT",
  "staff.access.hedf": "HEDF",
  "staff.access.hedo": "HEDO",
  "staff.access.henf": "HENF",
  "staff.access.heno": "HENO",
  "staff.access.reco": "RECO",
  "staff.access.recf": "RECF",
  "staff.access.het": "HET",
  "staff.access.notes": "Notas",
  "staff.access.all": "Todos",
  "staff.access.enter_date": "Fecha",
  "staff.access.fmt_time": "Ing / Salida",
  "staff.access.enter_date_bio": "Fecha Bio",
  "staff.access.fmt_time_bio": "Ing / Salida Bio",
  "staff.access.approve": "Aprobar",
  "staff.access.not_approve": "No Aprob.",
  "staff.access.payroll": "Nomina",
  "staff.access.shift_amount": "Valor Turno",
  "staff.access.shift_amount_extra": "Valor Turno Extra",
  "staff.access.shift_amount_transport": "Valor Transporte",
  "staff.access.wizard_daily": "Reporte Diario",
  "staff_access.daily_report.sections": "Secciones",
  "staff_access_extratime.daily_report": "Reporte de Acceso Diario",
  "staff.access.open": "Abierto",
  "staff.access.done": "Finalizado",
  "staff.access.approve_group_filter": "Filtrar",
  "staff.access.approve_group_access": "Aprobacion Grupo",
  "staff.access.compensatory_date": "Fecha Compensación",
  "staff.access.compensated": "Compensado",
  "staff.access.permissions": "Permisos",
  "staff.access.view_events": "Ver Novedades",
  "staff.access.shift_hours": "Hora Turno",
  "staff.access.shift_schedule_het": "HET Programado",
};

export default es;
